<template>
  <div class="blog_page">
    <!-- Help you to understand our Lastest news and Industry Info -->
    <Top title="资讯" content="" img="#FF9F85" searchBtn="搜索"
      imgMobile="/static/imgs/blog_m.png" :searchFlag="true" searchPlaceholder="搜索资讯..."
      @input="getInput($event)" @searchClick="getSearch()" @keydown.enter.native="getSearch()"></Top>
    <!-- <div class="blog" v-if="!content">
      <Skeleton type='list'></Skeleton>
    </div> -->
    <!-- <div class="blog" v-html="content"></div> -->
    <div class="blog_top_box">
      <div class="blog_tab_top">
        <div v-if="searchFlag == false" class="blog_tab_tabs">
          <div v-for="item in tab_content" :key="item.tab_id" :class="
            isActive == item.tab_id ? 'blog_tab_tabs_title blog_tab_tabs_active' : 'blog_tab_tabs_title'"
            @click="changeTab(item.tab_id)">
            {{ item.name }}
          </div>
          <div :class="isActive > -1 ? `blog_activer blog_activer${isActive}` : 'blog_activer'"></div>
        </div>
        <div v-else class="blog_tab_tabs">
          <div v-if="!catSearchFlag" class="blog_tab_tabs_search">
            Search results for: {{ this.searchTextShow }}
          </div>
          <div v-else class="blog_tab_tabs_search">
            Search results with tag : {{ this.catSearchTextShow }}
          </div>
        </div>
      </div>
      <div class="blog_tab_divide_line"></div>
    </div>

    <div class="blog_tab_bottom">
      <div class="blog_tab_content">
        <div v-for="(item, index) in tab_content_item" :key="index"
          :class="index % 3 == 0 ? 'blog_tab_content_box' : 'blog_tab_content_box blog_tab_content_box_margin'">
          <div class="blog_tab_content_box_show">
            <img class="blog_tab_content_box_img" :src="item.img" @click="changeRoute(item.id)"/>
            <div class="blog_tab_content_box_title" @click="changeTabByTermName(item.title)" :title="item.title">
              {{ item.title }}
            </div>
            <div class="blog_tab_content_box_date">{{ item.date }}</div>
            <div class="blog_tab_content_box_text" @click="changeRoute(item.id)">{{ item.text }}</div>
          </div>
        </div>
      </div>

      <div class="blog_tab_bottom_bottom">
        <Paging :page-index="currentPage" :total="count" :page-size="pageSize" @change="pageChange"></Paging>
      </div>
    </div>

    <FooterCN></FooterCN>
  </div>
</template>

<script>
import Header from "./common/header.vue";
import FooterCN from "./common/footerCNNew.vue";
import Top from "./common/top.vue";
import Skeleton from "./common/skeleton.vue";
import Paging from "./common/paging.vue";

export default {
  name: "Services",
  components: {
    Header,
    FooterCN,
    Top,
    Skeleton,
    Paging,
  },
  data () {
    return {
      // content: "",
      tab_content: [
        {
          tab_id: 1,
          term_id: "110,111,112,113",
          name: "所有",
        },
        {
          tab_id: 2,
          term_id: '110',
          name: "全球咨询",
        },
        {
          tab_id: 3,
          term_id: "111",
          name: "成功案例",
        },
        {
          tab_id: 4,
          term_id: '113',
          name: "运营干货",
        },
        {
          tab_id: 5,
          term_id: '112',
          name: "商机速递",
        },
      ],
      tab_content_item: [],
      obj: {
        id: null,
        img: "",
        date: "",
        title: "",
        text: "",
        content: ""
      },
      mobileFlag: false,
      searchFlag: false,
      searchLimitFlag: false,
      searchText: "",
      searchTextShow: "",

      catSearchFlag: false,
      catSearchTextShow: "",
      isActive: 1,
      currentPage: 1,
      pageSize: 9,
      count: 0,
    };
  },
  deactivated () {
    this.$destroy();
  },
  created () {
    // this.getData();
    document.title = '全球云店——想法即商业，开店即开张';;
    if (this.$route.query.cat) {
      this.getContentByID(this.$route.query.cat)
      this.searchFlag = true;
      this.catSearchFlag = true;
    } else if (this.$route.query.tag) {
      if (this.$route.query.page) {
        // console.log(this.$route.query.page);
        // console.log(parseInt(this.$route.query.page));
       this.currentPage = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
      }
      this.getContentByName(this.$route.query.tag)
      this.searchFlag = true;
      this.catSearchFlag = true;
    } else {
      this.getContent();
    }
    if (document.body.offsetWidth > 767) {
      this.pageSize = 9
      this.mobileFlag = false
    } else {
      this.pageSize = 6
      this.mobileFlag = true
    }
  },
  methods: {
    // 根据term_ids获取对应文章
    getContent () {
      this.tab_content_item = [];
      this.$axios.get(`https://gateway.antdiy.vip/website/posts?term_ids=${this.tab_content[this.isActive - 1].term_id}&page=${this.currentPage}&size=${this.pageSize}&need_term_name=true`)
        .then((res) => {
          if (res.data.success && res.data.posts) {
            this.count = res.data.count;
            for (let i = 0; i < res.data.posts.length; i++) {
              this.obj = {};
              this.obj.id = res.data.posts[i].id;
              this.obj.title = res.data.posts[i].term_name;
              this.obj.text = res.data.posts[i].post_title.replace(/&amp;/g,'&').replace(/&nbsp;/g, ' ').replace(/ /g," ");;
              this.obj.date = this.getTime(res.data.posts[i].post_date);
              this.obj.content = res.data.posts[i].post_content;
              this.getImageAndText(this.obj.content);

              // this.tab_content_item[this.tab_content_item.length] = this.obj;
              this.$set(this.tab_content_item, i, this.obj)
            }
            this.searchLimitFlag = false;
            // this.$forceUpdate();
          }
        });
    },
    // 替换时间格式
    getTime (str) {
      return str.slice(0, 10);
    },
    // 替换图片格式
    getImageAndText (str) {
      str = str.replace(/[\r\n]/g, ""); 
      var imgre = new RegExp(/<img.*?(?:>|\/>)/gi)  // 匹配所有的img标签
      var imgre2 = new RegExp(/<img.*/)  // 当img标签被换行时
      let strstr = str
      // console.log(str)
      strstr = strstr.match(imgre);
      if(!strstr){
        strstr = str
        strstr = strstr.match(imgre2);
      }
      // console.log(strstr)
      if (strstr) {
        let imgstr = strstr[0].match(/src=[\'\"]?([^\'\"]*)[\'\"]?/i, '')
        this.obj.img = imgstr[0].slice(5, -1)
      } else {
        this.obj.img = "./static/imgs/blog_default_img.jpg" // 默认图片
      }

    },
    // cearchClick () {
    //   this.currentPage = 1;
    //   this.getSearch();
    // },
    // 根据文章标题是否包含搜索内容去检索,搜索类别没有用
    getSearch () {
      this.tab_content_item = [];
      this.$axios.get(`https://gateway.antdiy.vip/website/posts?term_ids=104,105&name=${this.searchText.trim()}&page=${this.currentPage}&size=${this.pageSize}&need_term_name=true`)
        .then((res) => {
          if (res.data.success && res.data.posts) {
            this.count = res.data.count;
            for (let i = 0; i < res.data.posts.length; i++) {
              if (i==0) {
                // console.log(res.data)
              }
              this.obj = {};
              this.obj.id = res.data.posts[i].id;
              this.obj.title = res.data.posts[i].term_name;
              this.obj.text = res.data.posts[i].post_title.replace(/&amp;/g,'&').replace(/&nbsp;/g, ' ').replace(/ /g," ");;
              this.obj.date = this.getTime(res.data.posts[i].post_date);
              this.obj.content = res.data.posts[i].post_content
              this.getImageAndText(this.obj.content);

              // this.tab_content_item[this.tab_content_item.length] = this.obj;
              this.$set(this.tab_content_item, i, this.obj)
            }
            if (this.mobileFlag) {
              document.querySelector('.blog_tab_top').style.width = "100%"
              document.querySelector('.blog_top_box').style.width = "100%"
              document.querySelector('.blog_tab_divide_line').style.width = "100%"
            }
            this.searchFlag = true;
            this.catSearchFlag = false;
            this.searchTextShow = this.searchText;
            // this.$forceUpdate();
            this.searchLimitFlag = false;
          }
        })
    },
    // 上面一栏根据类别切换
    changeTab (tab_id) {
      this.currentPage = 1;
      this.count = 1;
      this.isActive = tab_id;
      this.getContent();
    },
    // 下面文章类别切换,触发滚动
    changeTabByTermName (term_name) {
      for (let i = 0; 1 < this.tab_content.length; i++) {
        if (this.tab_content[i].name == term_name) {
          this.changeTab(i + 1);
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
        }
      }
    },
    // 获取输入框内容
    getInput (e) {
      this.searchText = e;
    },
    //获取分页数据
    // getList () {
    //   //模拟
    //   let url = `/api/list/?pageSize=${this.pageSize}&currentPage=${this.currentPage}`;
    //   this.$http.get(url).then(({ body }) => {
    //     //子组件监听到count变化会自动更新DOM
    //     this.count = body.count;
    //     this.items = body.list;
    //   });
    // },
    //分页跳转,根据是否已经进行了搜索选择不同的获取文章方式
    pageChange (page) {
      while (this.searchLimitFlag == false) {
        this.currentPage = page;
        this.searchLimitFlag = true;
        if (!this.searchFlag) {
          this.getContent();
        } else {
          this.getSearch();
        }
      }
    },
    // 跳转链接
    changeRoute (id) {
      if (id) {
        window.open(`/cn/detail?p=${id}&from=blog`)
      }
    },
    //通过tagId获取列表
    getContentByID(id) {
      this.$axios.get(`https://gateway.antdiy.vip/website/posts?term_ids=${id}&page=${this.currentPage}&size=${this.pageSize}&need_term_name=true`)
        .then((res) => {
          if (res.data.success && res.data.posts) {
            this.count = res.data.count;
            for (let i = 0; i < res.data.posts.length; i++) {
              if ( i === 0 ) {
                this.catSearchTextShow = res.data.posts[0].term_name
              }
              this.obj = {};
              this.obj.id = res.data.posts[i].id;
              this.obj.title = res.data.posts[i].term_name;
              this.obj.text = res.data.posts[i].post_title.replace(/&amp;/g,'&').replace(/&nbsp;/g, ' ').replace(/ /g," ");
              this.obj.date = this.getTime(res.data.posts[i].post_date);
              this.obj.content = res.data.posts[i].post_content;
              this.getImageAndText(this.obj.content);

              // this.tab_content_item[this.tab_content_item.length] = this.obj;
              this.$set(this.tab_content_item, i, this.obj)
            }
            this.searchLimitFlag = false;
            // this.$forceUpdate();
          }
        });
    },
    //通过tagNAme获取tagID
    getContentByName(name) {
      this.$axios.get(`https://gateway.antdiy.vip/website/term?names=${name}`).then((res) => {
        if (res.data.success && res.data.terms) {
          this.getContentByID(res.data.terms[0].term_id)
        }
      })
    }
  },
};
</script>

<style>
.blog_top_box {
  overflow: hidden;
}
.blog_tab_top {
  width: 1200px;
  margin: 0 auto 0;
  height: 110px;
  position: relative;
}
.blog_tab_tabs {
  height: 110px;
  padding: 0 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.blog_tab_tabs_title {
  height: 40px;
  font-size: 24px;
  font-family: Helvetica;
  color: #222837;
  line-height: 40px;
  cursor: pointer;
}
.blog_tab_tabs_active {
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322 !important;
}
.blog_tab_tabs_search {
  height: 40px;
  font-size: 24px;
  font-family: Helvetica;
  color: #222536;
  line-height: 40px;
}

.blog_activer {
  height: 4px;
  background: #fc5322;
  border-radius: 2px;
  position: absolute;
  top: 107px;
  /* left: -33px;
    transform: translate(-50%, 0);  */
  transition: all 0.4s;
  opacity: 0;
}
.blog_activer1 {
  width: 48px;
  left: 125px;
  opacity: 1;
}
.blog_activer2 {
  width: 96px;
  left: 303px;
  opacity: 1;
}
.blog_activer3 {
  width: 96px;
  left: 529px;
  opacity: 1;
}
.blog_activer4 {
  width: 96px;
  left: 754px;
  opacity: 1;
}
.blog_activer5 {
  width: 96px;
  left: 980px;
  opacity: 1;
}
.blog_tab_divide_line {
  width: 1200px;
  margin: 0 auto 0;
  border-bottom: 1px solid rgba(151, 151, 151, 0.3);
}

.blog_tab_bottom {
  width: 1200px;
  margin: 0 auto 0;
  /* height: 1463px; */
  position: relative;
}
.blog_tab_content {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 200px;
  min-height: 300px;
}
.blog_tab_content_box {
  width: 376px;
  height: 410px;
  padding: 50px 0;
}
.blog_tab_content_box_margin {
  margin-left: 36px;
}
.blog_tab_content_box_img {
  width: 376px;
  height: 255px;
  margin-bottom: 15px;
  cursor: pointer;
}
.blog_tab_content_box_title {
  float: left;
  height: 24px;
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322;
  line-height: 24px;
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.blog_tab_content_box_title:hover {
  text-decoration: underline;
}
.blog_tab_content_box_date {
  float: right;
  height: 22px;
  max-width: 180px;
  font-size: 18px;
  font-family: Helvetica-Light, Helvetica;
  font-weight: 300;
  color: #6c717d;
  line-height: 22px;
  margin-top: 2px;
  overflow: hidden;
  white-space: nowrap;
}
.blog_tab_content_box_text {
  clear: both;
  padding-top: 20px;
  width: 376px;
  height: 68px;
  font-size: 20px;
  font-family: Helvetica;
  color: #32404d;
  line-height: 24px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.blog_tab_content_box_text:hover {
  text-decoration: underline;
}
/* .blog_tab_content_box_show{
    display: none;
  } */

.blog_tab_bottom_bottom {
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translate(-50%, 0);
}

@media (max-width: 767px) {
  /* .blog{
      padding: 1.61rem .46rem 1.15rem;
      width: 100%;
    }
    .blog h3{
      font-size: .42rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #222536;
      line-height: .58rem;
      margin: 0;
    }
    .blog ul li{
      font-size: .31rem;
      font-family: Helvetica;
      color: #222536;
      line-height: .48rem;
      position: relative;
    }
    
    .blog ul li + li{
      margin-top: .38rem;
    }
    .blog ul li + li::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background: #E6E7EC;
      top: -.19rem;
      left: 0;
    }
    .blog ul + h3{
      margin-top: 1.23rem;
    }
    .blog h3:before{
      top: -.4rem;
    }
    .blog ul{
      margin-top: .38rem;
    } */
  /* .mobile_search_box_blog {
    background: #ffffff !important;
  } */
  .blog_page {
    width: 100%;
  }
  .blog_top_box {
    width: 100%;
    overflow: auto;
  }
  .blog_tab_top {
    width: 11.5rem;
    margin: 0 auto 0;
    height: 1.04rem;
    position: relative;
    padding: 0 0.48rem;
  }
  .blog_tab_divide_line {
    width: 11.5rem;
    border-bottom: 0.01rem solid rgba(151, 151, 151, 0.3);
  }
  .blog_top_box::-webkit-scrollbar {
    /* 组件内滚动条不显示 */
    display: none;
  }
  .blog_tab_tabs {
    height: 1.04rem;
    padding: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .blog_tab_tabs_title {
    height: 0.4rem;
    font-size: 0.3rem;
    font-family: Helvetica;
    color: #222837;
    line-height: 0.4rem;
    cursor: pointer;
  }
  .blog_tab_tabs_search {
    height: 0.6rem;
    font-size: 0.3rem;
    font-family: Helvetica-blod, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.6rem;
  }
  .blog_activer {
    height: 0.04rem;
    background: #fc5322;
    border-radius: 0.02rem;
    position: absolute;
    top: 1rem;
    /* left: -33px;
    transform: translate(-50%, 0);  */
    transition: all 0.4s;
    opacity: 0;
  }
  .blog_activer1 {
    width: .44rem;
    left: 1.07rem;
    opacity: 1;
  }
  .blog_activer2 {
    width: .96rem;
    left: 2.75rem;
    opacity: 1;
  }
  .blog_activer3 {
    width: .96rem;
    left: 5rem;
    opacity: 1;
  }
  .blog_activer4 {
    width: .96rem;
    left: 7.2rem;
    opacity: 1;
  }
  .blog_activer5 {
    width: .96rem;
    left: 9.45rem;
    opacity: 1;
  }
  .blog_tab_bottom {
    width: 100%;
    margin: 0 auto 0;
    /* height: 14.63rem; */
    position: relative;
    padding: 0 0.48rem;
  }
  .blog_tab_content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 2rem;
    min-height: 3rem;
  }

  .blog_tab_content_box {
    width: 48.4%;
    height: 3.5rem;
    margin: 0.4rem 0 0;
    padding: 0;
  }
  .blog_tab_content_box_margin {
    margin-left: 0;
  }
  .blog_tab_content_box_img {
    width: 3.06rem;
    height: 2.06rem;
    margin-bottom: 0.15rem;
  }
  .blog_tab_content_box_title {
    float: left;
    height: 0.24rem;
    font-size: 0.2rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.24rem;
    max-width: 1.46rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .blog_tab_content_box_date {
    float: right;
    height: 0.22rem;
    max-width: 1.56rem;
    font-size: 0.18rem;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #6c717d;
    line-height: 0.22rem;
    margin-top: 0.02rem;
    overflow: hidden;
    white-space: nowrap;
  }
  .blog_tab_content_box_text {
    margin-top: 0.43rem;
    padding-top: 0;
    height: 0.72rem;
    font-size: 0.2rem;
    font-family: Helvetica;
    color: #32404d;
    line-height: 0.24rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .blog_tab_content_box_show {
    width: 3rem;
  }

  .blog_tab_bottom_bottom {
    position: absolute;
    bottom: 0.8rem;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .paging_bar {
    display: flex;
    height: 38px;
    padding: 0;
    margin: 0 0;
    font-size: 0;
    list-style: none;
    user-select: none;
  }
  .paging_bar li {
    width: 38px;
    height: 38px;
    font-size: 20px;
    font-family: Helvetica;
    color: rgba(0, 0, 0, 0.65);
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
  .paging_bar li:hover {
    color: #fc5322;
  }
  .paging_bar_current {
    background: #ffffff;
    border-radius: 2px;
    color: #fc5322 !important;
    border: 1px solid #fc5322;
  }
  .last_page {
    background: url("../assets/paging_bar_left.svg");
  }
  .last_page:hover {
    background: url("../assets/paging_bar_left_hover.svg") no-repeat 9px 8.5px;
  }
  .next_page {
    background: url("../assets/paging_bar_right.svg");
  }
  .next_page:hover {
    background: url("../assets/paging_bar_right_hover.svg") no-repeat 9px 8.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogcn.vue